import axios from 'axios'
import store from '@/store'

export default {
  signup(email, locale, token) {
    const data = {
      'client_id': store.getters.getApplication.clientId,
      'email': email,
      'locale': locale.toUpperCase(),
      'token': token
    }
    return axios.post('/api/v1/user/signup', data)
  },
  confirm(code, name, password) {
    const data = {
      code: code,
      name: name,
      password: password
    }
    return axios.put('/api/v1/user/confirm', data)
  },
  restore(email, token) {
    const data = {
      email: email,
      token: token
    }
    return axios.post('/api/v1/user/restore', data)
  },
  recover(code, password) {
    const data = {
      code: code,
      password: password
    }
    return axios.put('/api/v1/user/recover', data)
  },
  login(email, password, locale) {
    const data = {
      'client_id': store.getters.getApplication.clientId,
      'email': email,
      'password': password,
      'locale': locale.toUpperCase()
    }
    return axios.post('/api/v1/user/login', data)
  },
  logout() {
    return axios.get('/api/v1/user/logout')
  },
  profile() {
    return axios.get('/api/v1/user/profile')
  },
  saveProfile(name, password, locale, notifyMe) {
    const data = {}
    if (name) {
      data.name = name
    }
    if (password) {
      data.password = password
    }
    if (locale) {
      data.locale = locale
    }
    data.notify_me = notifyMe
    return axios.patch('/api/v1/user/profile', data)
  }
}
